<script lang="ts">
	import BylawsContent from './bylaws.svx';
</script>

<div class="prose prose-blue dark:prose-invert max-w-none">
	<BylawsContent />
</div>
